import {
    apiRequest,
    rumpunCreate
} from "../../../../../services/adapters/kepegawaian/rumpunService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", rumpunCreate, {
            body: query
        }, true)
    }
}

export default CreateRepository